export interface IAppSettings {
  APIUrl: string,
  PublicAPIUrl: string,
  Version: string,
  GoogleClientId: string,
  ApplicationName: string
}

export const AppSettings: IAppSettings = {
  APIUrl: "https://localhost:5001",
  PublicAPIUrl: "https://localhost:6001",
  Version: "1.0.0",
  GoogleClientId: "317399248822-u2seld36hjot7nf2p24oe3icm01aok51.apps.googleusercontent.com",
  ApplicationName: "3D Crate"
};

export async function loadConfig(): Promise<void> {
  const response = await fetch("/appsettings.json");
  const config = await response.json();

  AppSettings.APIUrl = config.APIUrl;
  AppSettings.PublicAPIUrl = config.PublicAPIUrl;
  AppSettings.Version = config.Version;
  AppSettings.GoogleClientId = config.GoogleClientId;
  AppSettings.ApplicationName = config.ApplicationName;
}
